import _defineProperty from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

import generateIdxAction from './generateIdxAction.js';
var generateRemediationFunctions = function generateRemediationFunctions(authClient, remediationValue) {
  var toPersist = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return remediationValue.reduce(function (obj, remediation) {
    return Object.assign(Object.assign({}, obj), _defineProperty({}, remediation.name, generateIdxAction(authClient, remediation, toPersist)));
  }, {});
};
export { generateRemediationFunctions };